// File: Components/ui/GuideLayout.jsx
import React from 'react';
import AuthorCard from './AuthorCard';
import config from '../../config/config';
import GuideHero from './GuideHero'

const GuideLayout = ({ children, author, ...restProps }) => {
  const content = React.isValidElement(children) && (author || Object.keys(restProps).length > 0)
  ? React.cloneElement(children, { author, ...restProps })
  : children;
  return (
    <div style={{width: "100%"}}>
      <GuideHero 
        title={restProps.title}
        level={restProps.level}
        icon={restProps.sidebar.icon}
      />
      <div className='content'>
        {/* Render the page content */}
        {content}

        {/* Only render the AuthorCard if we have an author prop */}
        {(author && config.showAuthors) && <AuthorCard author={author} />}
      </div>
    </div>

  );
};

export default GuideLayout;
